export const CheckboxTestAttributes = {
    errorText: 'checkbox-error-text',
};
